import { render } from "./ChatBotFullPage.vue?vue&type=template&id=203960b3&scoped=true"
import script from "./ChatBotFullPage.vue?vue&type=script&lang=js"
export * from "./ChatBotFullPage.vue?vue&type=script&lang=js"

import "./ChatBotFullPage.vue?vue&type=style&index=0&id=203960b3&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203960b3"]])

export default __exports__